// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__6ziKQ","column":"style_column__24s4t","row":"style_row__1eXq8"};